module.exports = __webpack_public_path__ + "2839c7e60b68779cf88808f6131d393f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-scarf-red-s.png
// module id = 2846
// module chunks = 0